var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52051 3.79102H6.77051V5.95768H3.52051V3.79102Z",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 8.12435H6.22917",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89551 11.375V2.70833C1.89551 2.10979 2.3803 1.625 2.97884 1.625H7.31217C7.91072 1.625 8.39551 2.10979 8.39551 2.70833V11.375",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5622 2.70898L11.3281 3.4749C11.5312 3.67803 11.6455 3.95373 11.6455 4.24082V9.47982C11.6455 9.92832 11.2815 10.2923 10.833 10.2923V10.2923C10.3845 10.2923 10.0205 9.92832 10.0205 9.47982V8.66732C10.0205 8.36832 9.77784 8.12565 9.47884 8.12565H8.39551",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6457 6.50065H10.6344C10.3089 6.50065 10.0564 6.21519 10.0971 5.89182L10.2325 4.80848C10.2661 4.53765 10.4963 4.33398 10.7698 4.33398H11.6457",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35449 11.3743H8.93783",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.283a21a9cab21150850285204d165cfd.svg";
export { ForwardRef as ReactComponent };